import React, { useState } from 'react';
import { Tabs, Tab } from 'react-bootstrap';

export default function MarketPairs({ onSelectSymbol }) {
  const [search, setSearch] = useState("");

  // Full pairs list (USDT markets)
  const pairs = [
    { name: "Bitcoin (BTC)", pair: "BTC/USDT", symbol: "BINANCE:BTCUSDT" },
    { name: "Ethereum (ETH)", pair: "ETH/USDT", symbol: "BINANCE:ETHUSDT" },
    { name: "Tether (USDT)", pair: "USDT/USDT", symbol: "BINANCE:USDTUSDT" },
    { name: "BNB (Binance Coin)", pair: "BNB/USDT", symbol: "BINANCE:BNBUSDT" },
    { name: "USD Coin (USDC)", pair: "USDC/USDT", symbol: "BINANCE:USDCUSDT" },
    { name: "XRP (Ripple)", pair: "XRP/USDT", symbol: "BINANCE:XRPUSDT" },
    { name: "Cardano (ADA)", pair: "ADA/USDT", symbol: "BINANCE:ADAUSDT" },
    { name: "Solana (SOL)", pair: "SOL/USDT", symbol: "BINANCE:SOLUSDT" },
    { name: "Dogecoin (DOGE)", pair: "DOGE/USDT", symbol: "BINANCE:DOGEUSDT" },
    { name: "Polkadot (DOT)", pair: "DOT/USDT", symbol: "BINANCE:DOTUSDT" },
    { name: "Polygon (MATIC)", pair: "MATIC/USDT", symbol: "BINANCE:MATICUSDT" },
    { name: "Shiba Inu (SHIB)", pair: "SHIB/USDT", symbol: "BINANCE:SHIBUSDT" },
    { name: "Litecoin (LTC)", pair: "LTC/USDT", symbol: "BINANCE:LTCUSDT" },
    { name: "Chainlink (LINK)", pair: "LINK/USDT", symbol: "BINANCE:LINKUSDT" },
    { name: "TRON (TRX)", pair: "TRX/USDT", symbol: "BINANCE:TRXUSDT" },
    { name: "Avalanche (AVAX)", pair: "AVAX/USDT", symbol: "BINANCE:AVAXUSDT" },
    { name: "Uniswap (UNI)", pair: "UNI/USDT", symbol: "BINANCE:UNIUSDT" },
    { name: "Cosmos (ATOM)", pair: "ATOM/USDT", symbol: "BINANCE:ATOMUSDT" },
    { name: "Ethereum Classic (ETC)", pair: "ETC/USDT", symbol: "BINANCE:ETCUSDT" },
    { name: "Chain (XCN)", pair: "XCN/USDT", symbol: "BINANCE:XCNUSDT" },
    { name: "Monero (XMR)", pair: "XMR/USDT", symbol: "BINANCE:XMRUSDT" },
    { name: "VeChain (VET)", pair: "VET/USDT", symbol: "BINANCE:VETUSDT" },
    { name: "Algorand (ALGO)", pair: "ALGO/USDT", symbol: "BINANCE:ALGOUSDT" },
    { name: "Filecoin (FIL)", pair: "FIL/USDT", symbol: "BINANCE:FILUSDT" },
    { name: "ApeCoin (APE)", pair: "APE/USDT", symbol: "BINANCE:APEUSDT" },
    { name: "Decentraland (MANA)", pair: "MANA/USDT", symbol: "BINANCE:MANAUSDT" },
    { name: "Axie Infinity (AXS)", pair: "AXS/USDT", symbol: "BINANCE:AXSUSDT" },
    { name: "Stellar (XLM)", pair: "XLM/USDT", symbol: "BINANCE:XLMUSDT" },
    { name: "Fantom (FTM)", pair: "FTM/USDT", symbol: "BINANCE:FTMUSDT" },
    { name: "Tezos (XTZ)", pair: "XTZ/USDT", symbol: "BINANCE:XTZUSDT" },
    { name: "The Sandbox (SAND)", pair: "SAND/USDT", symbol: "BINANCE:SANDUSDT" },
    { name: "Elrond (EGLD)", pair: "EGLD/USDT", symbol: "BINANCE:EGLDUSDT" },
    { name: "Hedera (HBAR)", pair: "HBAR/USDT", symbol: "BINANCE:HBARUSDT" },
    { name: "NEAR Protocol (NEAR)", pair: "NEAR/USDT", symbol: "BINANCE:NEARUSDT" },
    { name: "Terra (LUNA)", pair: "LUNA/USDT", symbol: "BINANCE:LUNAUSDT" },
    { name: "Paxos Standard (PAX)", pair: "PAX/USDT", symbol: "BINANCE:PAXUSDT" },
    { name: "Kusama (KSM)", pair: "KSM/USDT", symbol: "BINANCE:KSMUSDT" },
    { name: "Harmony (ONE)", pair: "ONE/USDT", symbol: "BINANCE:ONEUSDT" },
    { name: "EOS (EOS)", pair: "EOS/USDT", symbol: "BINANCE:EOSUSDT" },
    { name: "IOTA (IOTA)", pair: "IOTA/USDT", symbol: "BINANCE:IOTAUSDT" },
    { name: "Flow (FLOW)", pair: "FLOW/USDT", symbol: "BINANCE:FLOWUSDT" },
    { name: "Bitcoin Cash (BCH)", pair: "BCH/USDT", symbol: "BINANCE:BCHUSDT" },
    { name: "Zcash (ZEC)", pair: "ZEC/USDT", symbol: "BINANCE:ZECUSDT" },
    { name: "KuCoin Token (KCS)", pair: "KCS/USDT", symbol: "BINANCE:KCSUSDT" },
    { name: "GateToken (GT)", pair: "GT/USDT", symbol: "BINANCE:GTUSDT" },
    { name: "Quant (QNT)", pair: "QNT/USDT", symbol: "BINANCE:QNTUSDT" },
    { name: "SushiSwap (SUSHI)", pair: "SUSHI/USDT", symbol: "BINANCE:SUSHIUSDT" },
    { name: "Curve DAO Token (CRV)", pair: "CRV/USDT", symbol: "BINANCE:CRVUSDT" },
    { name: "Basic Attention Token (BAT)", pair: "BAT/USDT", symbol: "BINANCE:BATUSDT" },
    { name: "Chiliz (CHZ)", pair: "CHZ/USDT", symbol: "BINANCE:CHZUSDT" },
  ];

  // Filter search
  const filtered = pairs.filter((p) =>
    p.pair.toLowerCase().includes(search.toLowerCase()) ||
    p.name.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="market-pairs">

      {/* Search bar */}
      <div className="input-group mb10">
        <div className="input-group-prepend">
          <span className="input-group-text">
            <i className="icon ion-md-search"></i>
          </span>
        </div>
        <input
          type="text"
          className="form-control"
          placeholder="Search"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      <Tabs defaultActiveKey="usdt">
        <Tab eventKey="usdt" title="USDT">
          <table className="table">
            <thead>
              <tr>
                <th>Pairs</th>
                <th>Symbol</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((coin) => (
                <tr
                  key={coin.symbol}
                  onClick={() => onSelectSymbol(coin.symbol)}
                  style={{ cursor: "pointer" }}
                >
                  <td>{coin.pair}</td>
                  <td>{coin.name}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </Tab>
      </Tabs>
    </div>
  );
}
